import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useCart } from '../context/CartContext';

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('success'); // Default to success for manual payment
  const [paymentData, setPaymentData] = useState(null);
  const navigate = useNavigate();
  const { refreshCart } = useCart();

  useEffect(() => {
    // For manual payment system, we don't need to check session status
    // Just refresh cart and show success
    refreshCart();
  }, [refreshCart]);

  if (status === 'success') {
    return (
      <div className="min-h-screen flex items-center justify-center py-12" data-testid="payment-success">
        <div className="max-w-md w-full mx-4">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 text-center">
            <div className="h-20 w-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-12 w-12 text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900 mb-4">Payment Successful!</h1>
            <p className="text-slate-600 mb-6">
              Thank you for your purchase. Your order has been confirmed and will be processed shortly.
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/')}
                className="w-full btn-primary"
                data-testid="continue-shopping-button"
              >
                Continue Shopping
              </Button>
              <Button
                onClick={() => navigate('/products/ebooks')}
                variant="outline"
                className="w-full"
              >
                Browse More Products
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-12" data-testid="payment-error">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-4">Payment Status Unknown</h1>
          <p className="text-slate-600 mb-6">
            We're having trouble confirming your payment. Please check your email for confirmation or contact support.
          </p>
          <Button onClick={() => navigate('/')} className="w-full btn-primary">
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;